import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { WelcomeSeriesMountProps } from './WelcomeSeriesMount.tsx';

// No UFOLoadHold: an optional card must not hold page-load metrics.
const LazyWelcomeSeriesMount: LoadableType<WelcomeSeriesMountProps> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-WelcomeSeriesMount" */ './WelcomeSeriesMount.tsx'))
			.WelcomeSeriesMount,
});

export const WelcomeSeriesMountLoader = (props: WelcomeSeriesMountProps): React.JSX.Element => (
	<TransparentErrorBoundary attribution={Attribution.CONTENT_TYPES}>
		<LazyWelcomeSeriesMount {...props} />
	</TransparentErrorBoundary>
);
